import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { MessagesActions } from './messages.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { MessagesEffects } from './messages.effects';
import { AuthTokenActions } from '../auth-token/auth-token.actions';

export const initialState: ReadonlyArray<Message> = [];

export const messagesFeature = createFeature({
  name: 'messages',
  reducer: createReducer(
    initialState,
    on(AuthTokenActions.startSession, () => {
      return [];
    }),
    on(MessagesActions.addNewMessages, (state, { messages, donNotSave }) => {
      if (donNotSave) {
        return state;
      }
      if (state.length) {
        return [...state, ...messages];
      }
      return [...messages];
    }),
    on(MessagesActions.saveMessages, (state, { messages }) => {
      if (state.length) {
        return [...state, ...messages];
      }
      return [...messages];
    }),
    on(MessagesActions.removeLastNMessages, (state, { numberOfItems }) => {
      const messages = [...state];
      messages.splice(-numberOfItems);
      return [...messages];
    }),
    on(
      MessagesActions.updateLastMessage,
      MessagesActions.updateQuickReply,
      (state, { updatedMessage }) => {
        const messages = [...state];
        messages.pop();
        messages.push(updatedMessage);
        return [...messages];
      }
    )
  ),
});

export const { selectMessagesState } = messagesFeature;

export function provideMessagesFeature() {
  return makeEnvironmentProviders([
    provideState(messagesFeature),
    provideEffects(MessagesEffects),
  ]);
}
